import React, { Component, useEffect, useState } from "react";

import { Box } from "@material-ui/core";
import { AxlButton, AxlModal } from "axl-reactjs-ui";
import { saveAs } from "file-saver";
import { inject, observer } from "mobx-react";
import Slider from "react-slick";

// Utils
import { images } from "../../../constants/images";
import {openTrackingLink} from "../../../utils/common";

// Components
import ShipmentInfo from "../ShipmentInfo/";

// Styles
import { colors } from "../../../themes/colors";
import { KEY_DUPLICATED } from "../ShipmentUploadDetailPanel";
import styles, * as E from "./styles";

const ShipmentUploadDetail = ({ jobStore, shipmentStore, isBlur, match }) => {
  const [showShipmentPicture, setShowShipmentPicture] = useState(false);
  const [showSignaturePicture, setShowSignaturePicture] = useState(false);

  const { shipmentId, id } = match.params;

  const { selectedShipment, selectedJob } = jobStore;

  const download = (format) => (e) => {
    if (!selectedShipment) return;

    shipmentStore.getLabel(selectedShipment.id, format, (response) => {
      if (response.status === 200) {
        let contentType = "text/plain";
        let fileName = `order-${selectedShipment.id}-label.txt`;
        let blob;
        const data = response.data.label;
        if (format === "PDF") {
          contentType = "application/pdf";
          fileName = `order-${selectedShipment.id}-label.pdf`;
          blob = b64toBlob(data, contentType);
        } else if (format === "PNG") {
          contentType = "image/png";
          fileName = `order-${selectedShipment.id}-label.png`;
          blob = b64toBlob(data, contentType);
        } else {
          blob = new Blob([data], { type: "text/plain;charset=utf-8" });
        }

        saveAs(blob, fileName);
      }
    });
  };

  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  if (!selectedShipment || !selectedJob) {
    return null;
  }
  const stop_images =
    selectedShipment.pod && selectedShipment.pod.images
      ? selectedShipment.pod.images
      : [];
  const stop_signatures =
    selectedShipment.pod && selectedShipment.pod.signatures
      ? selectedShipment.pod.signatures
      : [];
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SliderNextArrow />,
    prevArrow: <SliderPrevArrow />,
  };

  useEffect(() => {
    if (shipmentId && id) {
      jobStore.getShipment(id, shipmentId);
    }
  }, []);

  return (
    <E.Panel>
      {jobStore.ERRORED.includes(selectedShipment.status) && (
        <E.PanelTop>
          <E.TextError>
            {selectedShipment.status === "UNSERVICEABLE"
              ? `UNSERVICEABLE. Shipment address is outside of serviceable regions or too far from pickup location`
              : `GEOCODE FAILED. Please edit the address and rerun the geocoder`}
          </E.TextError>
        </E.PanelTop>
      )}
      {selectedShipment?.duplicate_fields && (
        <E.PanelTop style={{backgroundColor: colors.lightOrange, color: '#000'}}>
          <Box fontFamily={'AvenirNext'} fontSize={13}>DUPLICATED: This shipment has duplicated field(s) {selectedShipment?.duplicate_fields?.replace(KEY_DUPLICATED.CLIENT_INTERNAL_SHIPMENT_ID, KEY_DUPLICATED.ORDER_ID)} with others.</Box>
        </E.PanelTop>
      )}
      <E.PanelMain style={{overflowY: 'auto'}}>
        <ShipmentInfo isBlur={isBlur} />
      </E.PanelMain>
      {!jobStore?.isDraftJob(selectedJob?.status) && (
        <E.PanelBottom>
          <E.Footer>
            <E.groupButtons>
              <AxlButton
                bg={"white"}
                compact={true}
                source={images.icon.camera}
                style={{ margin: "0px -1px", padding: "0", width: "50px" }}
                onClick={() => setShowShipmentPicture(true)}
              >
                {selectedShipment.pod && selectedShipment.pod.images
                  ? selectedShipment.pod.images.length
                  : 0}
              </AxlButton>
              <AxlButton
                bg={"white"}
                compact={true}
                source={images.icon.edit}
                style={{ margin: "0px -1px", padding: 0 }}
                onClick={() => setShowSignaturePicture(true)}
              >
                {selectedShipment.pod && selectedShipment.pod.signatures
                  ? selectedShipment.pod.signatures.length
                  : 0}
              </AxlButton>
              {showShipmentPicture && stop_images.length > 0 && (
                <AxlModal
                  onClose={() => setShowShipmentPicture(false)}
                  style={styles.modalStyle}
                  containerStyle={styles.modalContainer}
                >
                  <div style={styles.wrapImages}>
                    {stop_images && (
                      <Slider {...settings}>
                        {stop_images.map((img, index) => (
                          <div>
                            <div style={{ height: "100%" }} key={index}>
                              <img src={img.url} style={styles.imageShipment} />
                            </div>
                          </div>
                        ))}
                      </Slider>
                    )}
                  </div>
                </AxlModal>
              )}
              {showSignaturePicture && stop_signatures.length > 0 && (
                <AxlModal
                  onClose={() => setShowSignaturePicture(false)}
                  style={styles.modalStyle}
                  containerStyle={styles.modalContainer}
                >
                  <div style={styles.wrapImages}>
                    {stop_signatures && (
                      <Slider {...settings}>
                        {stop_signatures.map((img, index) => (
                          <div>
                            <div style={{ height: "100%" }} key={index}>
                              <img
                                src={img.image}
                                style={styles.imageShipment}
                              />
                            </div>
                          </div>
                        ))}
                      </Slider>
                    )}
                  </div>
                </AxlModal>
              )}
            </E.groupButtons>
            <AxlButton
              bg={"white"}
              compact={true}
              onClick={download("PDF")}
              source={images.icon.label}
            >{`Full Label`}</AxlButton>
            <E.groupButtons>
              <AxlButton
                bg={"white"}
                compact={true}
                style={{
                  margin: "0px -1px",
                  padding: "0 0 0 6px",
                  width: "85px",
                }}
              >
                {selectedShipment?.tracking_code ?? "..."}
              </AxlButton>
              <AxlButton
                onClick={() => openTrackingLink(selectedShipment?.tracking_code)}
                bg={"gray"}
                compact={true}
                source={images.icon.track}
                style={{ margin: "0px -1px", padding: "0 5px 0 0" }}
              >{`Track`}</AxlButton>
            </E.groupButtons>
          </E.Footer>
        </E.PanelBottom>
      )}
    </E.Panel>
  );
};

export default observer(inject('jobStore', 'shipmentStore')(ShipmentUploadDetail));

function SliderPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      style={{ ...styles.arrowButton, ...styles.arrowPrev }}
      onClick={onClick}
    >
      <i style={styles.arrowIcon} className="fa fa-angle-left" />
    </div>
  );
}

function SliderNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      style={{ ...styles.arrowButton, ...styles.arrowNext }}
      onClick={onClick}
    >
      <i style={styles.arrowIcon} className="fa fa-angle-right" />
    </div>
  );
}
